module.exports = __webpack_public_path__ + "img/Camera_Filled_24px_Icon_red.c5df5244.svg";